var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"circle",class:_vm.classObject})
}
var staticRenderFns = []

export { render, staticRenderFns }